import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCard = styled('div')(({ theme }) => ({
	boxSizing: 'border-box',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: 24,
	padding: 16,
	backgroundColor: theme.palette.neutral[0],
	border: `0.25px solid ${theme.palette.primary[200]}`,
	borderRadius: 16,
	boxShadow: '6px 9px 14px rgba(14, 28, 91, 0.1)',
}));

export const StyledHeader = styled(Stack)({
	flexDirection: 'row',
	alignItems: 'center',
	gap: 12,
});

export const StyledLogo = styled('img')({
	flexShrink: 0,
	width: 48,
	height: 48,
	borderRadius: '50%',
	objectFit: 'cover',
	display: 'block',
});

export const StyledLogoFallback = styled('div')(({ theme }) => ({
	flexShrink: 0,
	width: 48,
	height: 48,
	borderRadius: '50%',
	backgroundColor: theme.palette.solutions?.[100],
}));

export const StyledTitleGroup = styled('div')({
	flex: '1 1 0',
	minWidth: 0,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	gap: 2,
	wordBreak: 'break-word',
});

export const StyledValiditySection = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
});

export const StyledPriceRow = styled('div')({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 16,
});
